<vb-ui-data-grid [ngClass]="styles.logGrid" [rowData]="data" [columnDefs]="columnDefs">
</vb-ui-data-grid>
